import getDefaultLocale from './helpers/getDefaultLocale';
import getSupportedLocales from './helpers/getSupportedLocales';
import getInitialLocale from './helpers/getInitialLocale';
import reducerCreator from './reducerShared';

export default reducerCreator(() =>
  getInitialLocale(null, getSupportedLocales(), getDefaultLocale())
);
